// AuthForm.js
import React, { useState } from "react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import { app } from "../firebase";

const auth = getAuth(app);

const AuthForm = ({ onLogin }) => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePassword = (password) => {
    const lengthCheck = password.length >= 6;
    const numberCheck = /\d/.test(password);
    const upperCheck = /[A-Z]/.test(password);
    const lowerCheck = /[a-z]/.test(password);
    return lengthCheck && numberCheck && upperCheck && lowerCheck;
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");
    setEmailError("");
    setPasswordError("");

    if (!validateEmail(email)) {
      setEmailError("صيغة البريد الإلكتروني غير صحيحة");
      return;
    }

    if (isSignUp && !validatePassword(password)) {
      setPasswordError(
        "كلمة المرور يجب أن تكون 6 أحرف على الأقل وتحتوي على حرف كبير وحرف صغير ورقم"
      );
      return;
    }

    try {
      let userCredential;
      if (isSignUp) {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
      } else {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
      }
      onLogin(userCredential.user);
    } catch (err) {
      setError("خطأ: " + err.message);
    }
  };

  const handleGoogleLogin = async () => {
    setError("");
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      onLogin(result.user);
    } catch (err) {
      setError("خطأ في تسجيل الدخول عبر جوجل: " + err.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{isSignUp ? "إنشاء حساب" : "تسجيل الدخول"}</h2>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleAuth} style={styles.form}>
          <input
            type="email"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          {emailError && <p style={styles.validationError}>{emailError}</p>}

          <input
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          {passwordError && <p style={styles.validationError}>{passwordError}</p>}

          <button type="submit" style={styles.submitBtn}>
            {isSignUp ? "إنشاء حساب" : "تسجيل الدخول"}
          </button>
        </form>

        <p style={styles.switchText}>
          {isSignUp ? "لديك حساب بالفعل؟ " : "لا تملك حساب؟ "}
          <span
            style={styles.toggleLink}
            onClick={() => {
              setIsSignUp(!isSignUp);
              setError("");
              setEmailError("");
              setPasswordError("");
            }}
          >
            {isSignUp ? "تسجيل الدخول" : "إنشاء حساب"}
          </span>
        </p>

        <hr style={styles.divider} />

        <button onClick={handleGoogleLogin} style={styles.googleBtn}>
          تسجيل الدخول عبر جوجل
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    fontFamily: "'Tajawal', sans-serif",
    color: "#333",
    padding: "20px",
    boxSizing: "border-box",
  },
  card: {
    background: "#fff",
    padding: "30px 25px",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    width: "90%",
    maxWidth: "400px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "1.6rem",
    marginBottom: "20px",
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "12px",
    margin: "8px 0",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.3s",
  },
  submitBtn: {
    padding: "12px",
    marginTop: "12px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#667eea",
    color: "#fff",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background 0.3s",
  },
  googleBtn: {
    padding: "12px",
    width: "100%",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#db4437",
    color: "#fff",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background 0.3s",
  },
  divider: {
    margin: "20px 0",
    border: "none",
    borderTop: "1px solid #ccc",
  },
  toggleLink: {
    color: "#667eea",
    cursor: "pointer",
    textDecoration: "underline",
  },
  error: {
    color: "red",
    marginBottom: "10px",
    fontSize: "0.9rem",
  },
  validationError: {
    color: "orange",
    fontSize: "0.85rem",
    margin: "-5px 0 10px",
  },
  switchText: {
    margin: "10px 0",
    fontSize: "0.95rem",
  },
};

// Responsive tweaks
const mediaQuery = window.matchMedia("(max-width: 480px)");
if (mediaQuery.matches) {
  styles.card.padding = "20px 15px";
  styles.title.fontSize = "1.3rem";
  styles.input.fontSize = "0.9rem";
  styles.submitBtn.fontSize = "0.9rem";
  styles.googleBtn.fontSize = "0.9rem";
}

export default AuthForm;
